/* Sniff and Shift appearance controller: System, Light, Dark.
   Preference persists in localStorage('sns-appearance').
   The resolved mode is applied as html[data-sns-mode] so switching never
   reloads the page or resets cart, filter, or form state. */
(function () {
  var KEY = 'sns-appearance';
  var mq = window.matchMedia('(prefers-color-scheme: dark)');

  function pref() {
    var v = null;
    try { v = localStorage.getItem(KEY); } catch (e) {}
    return v === 'light' || v === 'dark' ? v : 'system';
  }

  function resolved(p) { return p === 'system' ? (mq.matches ? 'dark' : 'light') : p; }

  function apply(animate) {
    var mode = resolved(pref());
    var root = document.documentElement;
    if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('sns-anim');
      setTimeout(function () { root.classList.remove('sns-anim'); }, 300);
    }
    root.setAttribute('data-sns-mode', mode);
    var meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', mode === 'dark' ? '#10100F' : '#F8F7F4');
    document.querySelectorAll('[data-sns-set]').forEach(function (btn) {
      btn.setAttribute('aria-checked', btn.getAttribute('data-sns-set') === pref() ? 'true' : 'false');
    });
  }

  mq.addEventListener('change', function () { if (pref() === 'system') apply(true); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sns-set]');
    if (!btn) return;
    try { localStorage.setItem(KEY, btn.getAttribute('data-sns-set')); } catch (err) {}
    apply(true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(false); });
  } else {
    apply(false);
  }
})();
